var render = function render(){var _vm=this,_c=_vm._self._c;return _c('JobRevisionHeader',{attrs:{"title":"suspect_code_models"}})
}
var staticRenderFns = []

export { render, staticRenderFns }